import React, { useState, useEffect } from 'react';
import { BsBasketFill, BsHourglassSplit } from 'react-icons/bs';
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';
import { getAllOrderCounts } from '../../../Redux/features/order/orderSlice';
import { useDispatch, useSelector } from 'react-redux';
import BarCharts from '../../Pages/BarChart';

const AdminHome = () => {
	const dispatch = useDispatch();
	const { ordersCount, isLoading } = useSelector((state) => state.order);

	const [hasFetched, setHasFetched] = useState(false);

	useEffect(() => {
		if (ordersCount.length === 0 && !isLoading && !hasFetched) {
			dispatch(getAllOrderCounts());
			setHasFetched(true);
		}
	}, [dispatch, hasFetched, ordersCount.length, isLoading]);

	return (
		<div>
			<div className='flex justify-center items-center flex-wrap  md:pt-24 pt-12 px-4 md:gap-10 gap-2 md:px-10 md:mb-24 mb-10'>
				{/* Total Orders */}
				<div className='bg-white max-[400px]:w-full w-48 md:w-60  h-32 rounded-md shadow-xl flex justify-center items-center flex-col text-center'>
					<BsBasketFill className='text-[#FF6565] md:text-5xl text-3xl mb-2' />
					<p className='md:text-lg text-sm font-semibold'>Total Orders</p>
					<p className='font-bold '>{ordersCount.totalOrders}</p>
				</div>
				{/* Total Pending Orders */}
				<div className='bg-white max-[400px]:w-full w-48 md:w-60 h-32 rounded-md shadow-xl flex justify-center items-center flex-col text-center'>
					<BsHourglassSplit className='text-[#FFC107] md:text-5xl text-3xl mb-2' />
					<p className='md:text-lg text-sm font-semibold'> Pending Orders</p>
					<p className='font-bold'>{ordersCount.totalPendingOrders}</p>
				</div>
				{/* Total Completed Orders */}
				<div className='bg-white max-[400px]:w-full w-48 md:w-60 h-32 rounded-md shadow-xl flex justify-center items-center flex-col text-center'>
					<AiOutlineCheckCircle className='text-[#4CAF50] md:text-5xl text-3xl mb-2' />
					<p className='md:text-lg text-sm font-semibold'> Completed Orders</p>
					<p className='font-bold'>{ordersCount.totalCompletedOrder}</p>
				</div>
				{/* Total Cancelled Orders */}
				<div className='bg-white max-[400px]:w-full w-48 md:w-60 h-32 rounded-md shadow-xl flex justify-center items-center flex-col text-center'>
					<AiOutlineCloseCircle className='text-[#F44336] md:text-5xl text-3xl mb-2' />
					<p className='md:text-lg text-sm font-semibold'> Cancelled Orders</p>
					<p className='font-bold'>{ordersCount.totalCancelledOrders}</p>
				</div>
			</div>

			<div className=' flex justify-center items-center '>
				<div className='   '>
					<BarCharts />
				</div>
			</div>
		</div>
	);
};

export default AdminHome;
